<h2 mat-dialog-title>{{ dialogTitle }}</h2>
<form [formGroup]="newSupplierForm">
  <mat-dialog-content class="parameter-container">
    <div class="form-fields">
      <!-- Fuel Supplier Field -->
      <mat-form-field appearance="fill" class="custom-form-field">
        <mat-label>Fuel Supplier</mat-label>
        <input
          matInput
          formControlName="fuelSupplier"
          maxlength="100"
          (input)="onInput($event, 100)"
        />
        <!-- Error Message for Fuel Supplier Name -->
        <mat-error *ngIf="newSupplierForm.get('fuelSupplier')?.hasError('supplierExists')">
          This Fuel Supplier already exist in database.
        </mat-error>
      </mat-form-field>

      <!-- Station Manager Field -->
      <mat-form-field appearance="fill" class="custom-form-field">
        <mat-label>Station Manager</mat-label>
        <input
          matInput
          formControlName="stationManager"
          maxlength="50"
          (input)="onInput($event, 50)"
        />
      </mat-form-field>

      <!-- Address and SAP ID in one line -->
      <div class="address-sap-container">
        <!-- Address Field -->
        <mat-form-field appearance="fill" class="custom-form-field">
          <mat-label>Address</mat-label>
          <input
            matInput
            formControlName="address"
            maxlength="300"
            (input)="onInput($event, 300)"
          />
        </mat-form-field>

        <!-- SapId Field -->
        <mat-form-field appearance="fill" class="custom-form-field">
          <mat-label>SAP ID</mat-label>
          <input
            matInput
            formControlName="sapId"
            maxlength="15"
            (input)="onInput($event, 15)"
          />
          <mat-error *ngIf="newSupplierForm.get('sapId')?.hasError('invalidChars')">Only numbers are allowed</mat-error>
        </mat-form-field>
      </div>

      <!-- Remarks Field -->
      <mat-form-field appearance="fill" class="custom-form-field">
        <mat-label>Remarks</mat-label>
        <input
          matInput
          formControlName="remarks"
          maxlength="300"
          (input)="onInput($event, 300)"
        />
      </mat-form-field>
    </div>

    <!-- Media Section -->
    <div class="media-section">
      <div *ngIf="errorMessage" class="error-message">{{ errorMessage }}</div>
      <div class="media-header">MEDIA</div>
      <div class="media-wrapper">
        <table class="media-table">
          <thead>
          <tr>
            <th>MEDIA NO</th>
            <th>MEDIA TYPE</th>
            <th>CONTACT TYPE</th>
            <th>CONTACT</th>
            <th>ACTIONS</th>
          </tr>
          </thead>
          <tbody formArrayName="media">
          <tr
            *ngFor="let media of mediaArray.controls; let i = index"
            [formGroupName]="i"
          >
            <td class="center">
              {{ getMediaGroup(i).get('mediaNo')?.value }}
            </td>
            <td>
              <div class="form-field-container">
                <mat-form-field appearance="outline" class="custom-form-field">
                  <mat-select
                    formControlName="mediaType"
                    placeholder="Select type"
                    (selectionChange)="
                        updateMediaNumbers();
                        setContactValidators(getMediaGroup(i))
                      "
                  >
                    <mat-option value="PHONE">Phone</mat-option>
                    <mat-option value="EMAIL">Email</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </td>
            <td>
              <div class="form-field-container">
                <mat-form-field appearance="outline" class="custom-form-field">
                  <mat-select
                    formControlName="contactType"
                    placeholder="Select contact type"
                  >
                    <mat-option value="ACCOUNT MANAGER">Account Manager</mat-option>
                    <mat-option value="OPS">OPS</mat-option>
                    <mat-option value="ACCOUNTING">Accounting</mat-option>
                  </mat-select>
                </mat-form-field>
              </div>
            </td>
            <td>
              <div class="form-field-container">
                <mat-form-field appearance="outline" class="custom-form-field">
                  <input
                    matInput
                    formControlName="contactDetails"
                    placeholder="Enter contact details"
                    [attr.maxLength]="100"
                  />
                  <mat-error *ngIf="media.get('contactDetails')?.hasError('required')">
                    Contact is required
                  </mat-error>
                  <mat-error *ngIf="media.get('contactDetails')?.hasError('pattern')">
                    {{
                      media.get('mediaType')?.value === 'PHONE'
                        ? 'Only numbers are allowed'
                        : 'Invalid email format'
                    }}
                  </mat-error>
                  <mat-error *ngIf="media.get('contactDetails')?.hasError('email')">
                    Invalid email address
                  </mat-error>
                </mat-form-field>
              </div>
            </td>
            <td class="button-column">
              <button mat-icon-button color="warn" (click)="removeMedia(i)">
                <mat-icon>remove_circle</mat-icon>
              </button>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <button mat-stroked-button class="button-color" (click)="addMedia()">
        <mat-icon>add_circle</mat-icon> Add Media
      </button>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button
      mat-button
      cdkFocusInitial
      [disabled]="!newSupplierForm.valid"
      (click)="saveSupplier()"
    >
      Save
    </button>
  </mat-dialog-actions>
</form>
